import { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';

/**
 * Props of InteractiveTooltip component
 *
 * @author Vitalii Bodnarchuk, Sergii Goncharuk
 */
interface InteractiveTooltipProps extends PropsWithChildren, Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  /**
   * content of tooltip
   */
  readonly items: ReadonlyArray<ReactNode>;

  /**
   * content of tooltip
   */
  readonly content?: JSX.Element;

  /**
   * behavior of tooltip
   */
  readonly behavior?: 'click' | 'focus' | 'hover';

  readonly position?: 'right' | 'bottom';
}

enum InteractiveTooltipBehavior {
  CLICK = 'click',
  FOCUS = 'focus',
  HOVER = 'hover',
}

export { InteractiveTooltipBehavior };
export type { InteractiveTooltipProps };
